import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { ToastService } from 'src/app/shared/services/toast/toast.service';

@Component({
  selector: 'app-customer-plan-item-cancel-reason-dialog',
  templateUrl: './customer-plan-item-cancel-reason-dialog.component.html',
  styleUrls: ['./customer-plan-item-cancel-reason-dialog.component.sass'],
})
export class CustomerPlanItemCancelReasonDialogComponent implements OnInit {
  typeCes: TypeCesEnum;
  element: any;
  title = '';

  constructor(
    public toastService: ToastService,
    public dialogRef: MatDialogRef<CustomerPlanItemCancelReasonDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    data: {
      title: string;
      typeCes: TypeCesEnum;
      element: any;
    }
  ) {
    this.typeCes = data.typeCes;
    if (data?.title) this.title = data.title;
    if (data?.element) this.element = data.element;
  }

  get typeCesEnum() {
    return TypeCesEnum;
  }

  ngOnInit(): void {}

  public clickNo() {
    this.dialogRef.close(false);
  }

  public clickOk() {
    if (this.element?.cancellationReason)
      this.dialogRef.close({
        result: true,
        cancellationReason: this.element?.cancellationReason?.toUpperCase(),
      });
    else this.toastService.showWarn('Informe o motivo do cancelamento.');
  }
}
